import { registerGlobalService } from "../service-provider/ServiceRegistry";
import { globalModule } from "..//service-provider/GlobalModule";
import { http } from "../http/HttpService";
import { appSessionStorage } from "../storage/SessionStorageService";
import { browser } from "../browser-info/BrowserService";

export interface Configuration {
  get: () => Promise<any>;
}
export class ConfigurationService implements Configuration {
  get = async () => {
    let configFromStorage = appSessionStorage?.getStorageItem("config-storage");
    if (!configFromStorage) {
      configFromStorage = await this.loadConfigFromFile();
      appSessionStorage?.setStorageItem("config-storage", configFromStorage);
    }
    return configFromStorage;
  };

  private async loadConfigFromFile() {
    let response = await http.get("/configurations/config.json");
    let configuration = this.getConfigurationFromContent(response.data);
    return configuration;
  }

  private getConfigurationFromContent(content: any) {
    let commontProperties = content.all;
    let stage = this.findStageForDomain(content, browser.hostname);
    return { ...commontProperties, ...stage };
  }

  private findStageForDomain(content: any, domain: string) {
    return content.stages.find((stage: any) => stage.domain === domain);
  }
}

export const configuration = new ConfigurationService();
globalModule.configuration = configuration;
export default registerGlobalService(configuration as Configuration);
